import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'

export function useAccessCompany() {
  const page = usePage()

  const company = computed(() => page.props.auth.company)
  const defaultLocationName = computed(() => company.value.settings?.default_location_name || 'Default Store')
  const companyTimezone = computed(() => company.value.timezone)

  return { company, defaultLocationName, companyTimezone }
}
